import { Injectable } from '@angular/core';

@Injectable()
export class ToolsService {
  public strDay: any;
  public strMes2: any;
  constructor() { }
  dtOptions: DataTables.Settings = {};

  OpcionesTabla(intoption: any) {

    if (intoption == 0) {
      this.dtOptions[0] = {
        pagingType: 'full_numbers',
        pageLength: 10,
        autoWidth: false,
        responsive: true,
        language: {
          processing: "Procesando...",
          search: "Buscar:",
          lengthMenu: "Mostrar _MENU_ Registro",
          info: "Mostrando desde _START_ al _END_ de _TOTAL_ elementos",
          infoEmpty: "Mostrando ningún elemento.",
          infoFiltered: "(filtrado _MAX_ elementos total)",
          infoPostFix: "",
          loadingRecords: "Cargando registros...",
          zeroRecords: "No se encontraron registros",
          emptyTable: "No hay datos disponibles en la tabla",
          paginate: {
            first: "Primero",
            previous: "Anterior",
            next: "Siguiente",
            last: "Último"
          },
          buttons: {
            copy: 'Copiar',
            colvis: 'Columnas Visibles',
            copyTitle: 'Copiar al portapapeles',
            copySuccess: 'Se han copiado %d filas al portapapeles',
            copyKeys: 'Pulse <i>ctrl</i> o <i>\u2318</i> + <i>C</i> para copiar datos de la tabla a su portapapeles. <br><br>Para cancelar, haga clic en este mensaje o pulse Esc.',
            print: 'Imprimir',
          },
          aria: {
            sortAscending: ": Activar para ordenar la tabla en orden ascendente",
            sortDescending: ": Activar para ordenar la tabla en orden descendente"
          }
        },

      }
      return this.dtOptions[0];

    }
    if (intoption == 10) {
      this.dtOptions[10] = {
        pagingType: 'full_numbers',
        pageLength: 10,
        autoWidth: true,
        responsive: true,
        language: {
          processing: "Procesando...",
          search: "Buscar:",
          lengthMenu: "Mostrar _MENU_ Registro",
          info: "Mostrando desde _START_ al _END_ de _TOTAL_ elementos",
          infoEmpty: "Mostrando ningún elemento.",
          infoFiltered: "(filtrado _MAX_ elementos total)",
          infoPostFix: "",
          loadingRecords: "Cargando registros...",
          zeroRecords: "No se encontraron registros",
          emptyTable: "No hay datos disponibles en la tabla",
          paginate: {
            first: "Primero",
            previous: "Anterior",
            next: "Siguiente",
            last: "Último"
          },
          buttons: {
            copy: 'Copiar',
            colvis: 'Columnas Visibles',
            copyTitle: 'Copiar al portapapeles',
            copySuccess: 'Se han copiado %d filas al portapapeles',
            copyKeys: 'Pulse <i>ctrl</i> o <i>\u2318</i> + <i>C</i> para copiar datos de la tabla a su portapapeles. <br><br>Para cancelar, haga clic en este mensaje o pulse Esc.',
            print: 'Imprimir'
          },
          aria: {
            sortAscending: ": Activar para ordenar la tabla en orden ascendente",
            sortDescending: ": Activar para ordenar la tabla en orden descendente"
          }
        },
        dom: 'Bfrtip',

      }
      return this.dtOptions[10];
    }
  }

  ColorUsuario(rol) {
    if (rol == 0) {
      $('head').append('<link rel="stylesheet"  href="assets/estilosAdmin/css/mainPaciente.css" type="text/css"/>');
    }
    if (rol == 1) {
      $('head').append('<link rel="stylesheet"  href="assets/estilosAdmin/css/main.css" type="text/css"/>');
    }
    if (rol == 2) {
      $('head').append('<link rel="stylesheet"  href="assets/estilosAdmin/css/mainMedico.css" type="text/css"/>');
    }
    if (rol == 3) {
      $('head').append('<link rel="stylesheet"  href="assets/estilosAdmin/css/mainOdontologo.css" type="text/css"/>');
    }
    if (rol == 4) {
      $('head').append('<link rel="stylesheet"  href="assets/estilosAdmin/css/mainEnfermera.css" type="text/css"/>');
    }
    if (rol == 12) {
      $('head').append('<link rel="stylesheet"  href="assets/estilosAdmin/css/mainFarmacia.css" type="text/css"/>');
    }
  }

}


